
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/booking/packages",
      function () {
        return require("private-next-pages/booking/packages/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/booking/packages"])
      });
    }
  